import React from "react";
import { toAbsoluteUrl } from "../../services";

function Authlayout(props) {
  let { url , isOtp} = props;

  return (
    <div>
      {/* Header Start */}
      <div
        className="w-full bg-cover flex flex-col  items-center"
        style={{
          backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg.png")})`,
          height: "17rem",
        }}
      >
        <img
          alt="Logo"
          src={toAbsoluteUrl("/media/login/logo.png")}
          className="h-20 mt-14"
        />

        {props.children}
      </div>
      {/* Header End */}

      {/* Footer Start */}
      <div
        style={ isOtp ? { right : 0 , bottom : 0 , width : "100%"} : { 
          position: "fixed",
          right: "10px",
          bottom: props.top ? props.top :0,
        }}
      >
        <img
          src={toAbsoluteUrl(`${url}`)}
          alt="Footer Background"
          className={`absolute-z-[10] ${
            props.width ? "w-full" : "w-[96%]  ml-8"
          } `}
        />
        {/* Footer End */}
      </div>
    </div>
  );
}

export default Authlayout;
